import Block from "../Toiture/Block"
import charpenteItemData from "./CharpenteData"
import CharpenteBanner from "./CharpenteBanner"
import BlockCharpente from "../../Components/Block-charpente/BlockCharpente"

const Charpente = () => {

    return(
        <>
            <div class="bg-light">
                <CharpenteBanner/>
                <div className="container">
                    {
                        charpenteItemData.map((block, index) => (
                            block.isBlockA ?(
                                <Block 
                                    key={index}
                                    blockTitle={block.blocTitle}
                                    blockContent={block.blocContent}
                                    hasInput={block.hasInput}
                                />
                            ):(
                                <BlockCharpente
                                    key={index}
                                    blockTitle={block.blocTitle}
                                    blockContent={block.blocContent}
                                />
                            )
                        ))
                    }
                </div>
            </div>
        </>
    )

}

export default Charpente